/* @ngInject */

export default ($mdUtil, uiService) => {
  return {
    restrict: 'A',
    scope: {
      stWhenScrolled: '&'
    },
    link(scope, element, attr) {
      const sourceElement = attr.stWhenScrolledIn || 'md-content';
      const breakpointElement = attr.stWhenScrolledTo || '#whenScrolled';
      const scrollEventWithDelay = $mdUtil.debounce(function () {
        // eslint-disable-next-line no-undef
        if (verge.inY(angular.element(breakpointElement))) {
          uiService.scopeApply(scope.stWhenScrolled);
        }
      }, 50);
      angular.element(sourceElement).on('scroll', scrollEventWithDelay);
    }
  };
};
